// @ts-nocheck
import { useEffect, useRef, useReducer, useCallback } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"


export const TerrainProfileComponents = (props) => {
    const toast = useRef(null);
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    const terrainProfileOutput = useCallback((event) => {
        if (event.success) {
            toast.current.show({ severity: 'info', summary: '分析資訊', detail: '請稍後......' });
            let terrainHeight = [];
            let terrainBaseX = (event.geo.Buffer[1].x - event.geo.Buffer[0].x) / 99;
            let terrainX = [];
            for (let i = 0; i < 100; i++) {
                terrainX.push(event.geo.Buffer[0].x + terrainBaseX * i)
            }
            let data = {
                "LAYERNAME": window.main.OView.name,
                "SAMPLE_SIZE": 100,
                "EPSG": 4326,
                "GEO": {
                    "type": "LineString",
                    "coordinates": [[event.geo.Buffer[0].x, event.geo.Buffer[0].y], [event.geo.Buffer[1].x, event.geo.Buffer[1].y]]
                }
            }
            const url = "https://mapserver.pilotgaea.com.tw/oviewTLS12.aspx?http://127.0.0.1:8080/docmd?cmd=OV_GET_TERRAIN_PROFILE";
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(
                    data
                )
            })
                .then(res => res.json())
                .then((data) => {
                    if (data.SUCCESS) {
                        for (let i = 0; i < data.PROFILE.length; i++) {
                            terrainHeight.push(data.PROFILE[i]);
                        }
                        let terrainProfileValue = {
                            labels: terrainX,
                            datasets: [
                                {
                                    label: "Height(m)",
                                    data: terrainHeight,
                                    fill: true,
                                    borderColor: '#42A5F5',
                                    tension: .5
                                }
                            ]
                        }
                        props.setTerrainProfileValue(terrainProfileValue);
                        props.setTerrainProfileOpen(true);
                        forceUpdate();
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: '分析資訊', detail: '發生錯誤，請再試一次' });
                    }
                });
        }
        else {
            toast.current.show({ severity: 'error', summary: '分析資訊', detail: '發生錯誤，請再試一次' });
        }
    }, [props]);


    useEffect(() => {
        return () => {
            window.main.OView.removeEventListener("InputCompleted", terrainProfileOutput);
            window.main.OView.abortInput();
            window.main.OView.updateScreen();
        }
    }, [terrainProfileOutput]);



    const terrainProfileStart = () => {
        window.main.OView.addEventListener("InputCompleted", terrainProfileOutput);
        toast.current.show({ severity: 'info', summary: '分析資訊', detail: '請點擊滑鼠左鍵開始選取範圍' });
        window.main.OView.inputSurfacePolyline(null, null, null, null, 2);
    }

    return (
        <div>
            <Toast ref={toast} />
            <Button label="開始分析" className="p-button-rounded p-button-info" onClick={terrainProfileStart} style={{ width: "100%" }} />
        </div>
    )
}